<template>
  <div class="serviceInventory-container">
    <a-page-header
      class="page-header"
      :ghost="false"
      style="margin-bottom: 16px"
    >
      <template #title>
        <a-space size="middle">
          <a-icon type="golden" theme="filled" />
          <span>信息系统台账</span>
        </a-space>
      </template>
      <span>信息系统台账包含责任处室、业务系统名称等信息。</span>
    </a-page-header>

    <a-card :bordered="false" style="margin-bottom: 16px">
      <list-layout
        :getTableDataFunc="getTableDataFunc"
        :columnsAll="columnsAll"
        :columnDefaultSelected="columnDefaultSelected"
        :exportFunc="exportFunc"
        :toolsList="['setting', 'reload', 'leftTool', 'export', 'search']"
        :refresh="refresh"
        :search-type-options="[
          { label: '责任处室', value: 'department' },
          { label: '业务系统名称', value: 'name' },
          { label: '项目名称', value: 'project' },
          { label: '系统负责人', value: 'project_manager' },
          { label: '运维公司', value: 'operation_company' }
        ]"
      >
        <template #leftTool>
          <create-button
            v-permission="{action: 'base.inventory.create', effect: 'disabled'}"
            @click="$refs.inputDrawer.show()"
          ></create-button>
        </template>
        <template #rightTool>
          <upload-button
            v-permission="{action: 'base.inventory.update'}"
            @click="$refs.uploadModal.show()"
          ></upload-button>
        </template>

        <!-- 自定义列 -->
        <template #operationCompany="{ slotProps }">
          <span v-if="slotProps.text">{{ slotProps.text.name }}</span>
          <span v-else>-</span>
        </template>

        <template #lastLevel="{ slotProps }">
          <a-tag v-if="slotProps.text !== null && slotProps.text !== undefined && slotProps.text !== ''" :color="getLevelColor(slotProps.text)">{{ $t(`service_level.${slotProps.text}`) }}</a-tag>

          <span v-else>-</span>
        </template>

        <!-- 操作 -->
        <template #operation="{ slotProps }">
          <edit-button
            v-permission="{action: 'base.inventory.update', effect: 'disabled'}"
            @click="$refs.inputDrawer.show(slotProps.record.id)"
          ></edit-button>
          <delete-button
            v-permission="{action: 'base.inventory.delete', effect: 'disabled'}"
            @confirm="confirm(slotProps.record.id)"
          ></delete-button>
        </template>
      </list-layout>
    </a-card>

    <input-drawer ref="inputDrawer" @ok="confirm"></input-drawer>
    <upload-modal ref="uploadModal" @confirm="uploadConfirm"></upload-modal>
  </div>
</template>

<script>
import {
  getServiceInventoryList,
  deleteServiceInventory,
  exportServiceInventory
} from '@/api/inventory.js'
import ListLayout from '@/components/ListLayout.vue'
import CreateButton from '@/components/button/CreateButton.vue'
import InputDrawer from './modules/InputDrawer.vue'
import UploadButton from '@/components/button/UploadButton.vue'
import UploadModal from './modules/UploadModal.vue'
import DeleteButton from '@/components/button/DeleteButton'
import EditButton from '@/components/button/EditButton'

export default {
  name: 'ServiceInventory',
  components: {
    ListLayout,
    CreateButton,
    InputDrawer,
    UploadButton,
    UploadModal,
    DeleteButton,
    EditButton
  },
  data () {
    return {
      getTableDataFunc: getServiceInventoryList,
      exportFunc: exportServiceInventory,
      refresh: false,
      columnsAll: [
        {
          dataIndex: 'department',
          title: '责任处室',
          width: 130,
          ellipsis: true,
          scopedSlots: {
            customRender: 'department'
          }
        },
        {
          dataIndex: 'name',
          title: '业务系统名称',
          width: 140,
          ellipsis: true,
          scopedSlots: {
            customRender: 'name'
          }
        },
        {
          dataIndex: 'project',
          title: '项目名称',
          width: 140,
          ellipsis: true,
          scopedSlots: {
            customRender: 'project'
          }
        },
        {
          dataIndex: 'built_at',
          title: '建设时间',
          width: 160,
          scopedSlots: {
            customRender: 'builtAt'
          }
        },
        {
          dataIndex: 'launched_at',
          title: '上线时间',
          width: 160,
          scopedSlots: {
            customRender: 'launchedAt'
          }
        },
        {
          dataIndex: 'contract_amount',
          title: '合同金额',
          width: 160,
          scopedSlots: {
            customRender: 'contractAmount'
          }
        },       
        {
          dataIndex: 'contract_end_date',
          title: '合同到期时间',
          width: 160,
          scopedSlots: {
            customRender: 'contractEndDate'
          }
        },      
        {
          dataIndex: 'contract_funding_source',
          title: '合同资金来源',
          width: 160,
          scopedSlots: {
            customRender: 'contractFundingSource'
          }
        },

        {
          dataIndex: 'signed_at',
          title: '项目合同签订日期',
          width: 160,
          scopedSlots: {
            customRender: 'signedAt'
          }
        },
        {
          dataIndex: 'last_level',
          title: '最近一次等保级别',
          width: 160,
          scopedSlots: {
            customRender: 'lastLevel'
          }
        },
        {
          dataIndex: 'last_evaluated_at',
          title: '最近一次等保测评完成时间',
          width: 200,
          scopedSlots: {
            customRender: 'lastEvaluatedAt'
          }
        },
        {
          dataIndex: 'evaluate_company',
          title: '等保测评公司',
          width: 140,
          ellipsis: true,
          scopedSlots: {
            customRender: 'evaluateCompany'
          }
        },
        {
          dataIndex: 'evaluate_manager',
          title: '等保测评负责人',
          width: 140,
          ellipsis: true,
          scopedSlots: {
            customRender: 'evaluateManager'
          }
        },
        {
          dataIndex: 'evaluate_manager_phone',
          title: '等保测评负责人联系电话',
          width: 200,
          ellipsis: true,
          scopedSlots: {
            customRender: 'evaluateManagerPhone'
          }
        },
        {
          dataIndex: 'last_tested_at',
          title: '最近一次软测时间',
          width: 160,
          scopedSlots: {
            customRender: 'lastTestedAt'
          }
        },
        {
          dataIndex: 'test_company',
          title: '软件测评公司',
          width: 140,
          ellipsis: true,
          scopedSlots: {
            customRender: 'testCompany'
          }
        },
        {
          dataIndex: 'test_manager',
          title: '软测负责人',
          width: 140,
          ellipsis: true,
          scopedSlots: {
            customRender: 'testManager'
          }
        },
        {
          dataIndex: 'test_manager_phone',
          title: '软测负责人联系电话',
          width: 160,
          scopedSlots: {
            customRender: 'testManagerPhone'
          }
        },
        {
          dataIndex: 'project_manager',
          title: '系统负责人',
          width: 140,
          ellipsis: true,
          scopedSlots: {
            customRender: 'projectManager'
          }
        },
        {
          dataIndex: 'project_manager_phone',
          title: '系统负责人联系电话',
          width: 160,
          ellipsis: true,
          scopedSlots: {
            customRender: 'projectManagerPhone'
          }
        },
        {
          dataIndex: 'record_number',
          title: '备案证号码',
          width: 160,
          ellipsis: true,
          scopedSlots: {
            customRender: 'recordNumber'
          }
        },
        {
          dataIndex: 'recorded_at',
          title: '备案时间',
          width: 160,
          scopedSlots: {
            customRender: 'recordedAt'
          }
        },
        {
          dataIndex: 'address',
          title: '网址',
          width: 180,
          ellipsis: true,
          scopedSlots: {
            customRender: 'address'
          }
        },
        {
          dataIndex: 'operation_company',
          title: '运维公司',
          width: 160,
          ellipsis: true,
          scopedSlots: {
            customRender: 'operationCompany'
          }
        },
        {
          dataIndex: 'operation_company.manager',
          title: '运维公司负责人',
          width: 160,
          ellipsis: true,
          scopedSlots: {
            customRender: 'operationCompanyManager'
          }
        },
        {
          dataIndex: 'operation_company.phone_number',
          title: '运维公司负责人联系电话',
          width: 200,
          ellipsis: true,
          scopedSlots: {
            customRender: 'operationCompanyManagerPhone'
          }
        }
      ],
      columnDefaultSelected: [
        'department',
        'name',
        'project',
        'built_at',
        'launched_at',
        'contract_amount',
        'contract_end_date',
        'contract_funding_source',
        'signed_at',
        'last_level',
        'project_manager',
        'operation_company',
        'operation_company.manager'
      ]
    }
  },
  created () {
    // this.fetch()
  },
  methods: {
    async confirm (id = '') {
      if (id) {
        await deleteServiceInventory(id).then(res => {
          this.$message.success(res.message)
        })
      }
      this.refresh = !this.refresh
    },
    uploadConfirm () {
      this.refresh = !this.refresh
    },
    getLevelColor (c) {
      if (c === 2) return '#ffbc75'
      if (c === 3) return '#ffab53'
      if (c === 4) return '#ff9a30'
      if (c === 5) return '#ff890e'
      return '#ffcc98'
    }
  }
}
</script>
